import i18next from 'i18next';

import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import global_en from '../en/global.json';
import global_es from '../es/global.json';
import signin_en from '../en/signin'
import signin_es from '../es/signin'
import registerTra_en from '../en/registerTra';
import registerTra_es from '../es/registerTra'
import TestTras_es from '../es/TestTras.json'
import TestTras_en from '../en/TestTras.json'
import FooterRoutesTraslate_es from '../es/FooterRoutesTraslate';
import FooterRoutesTraslate_en from '../en/FooterRoutesTraslate';
import DeskTraslate_en from '../en/MyDeskTraslate';
import DeskTraslate_es from '../es/MyDeskTraslate';
import MyConfiguration_en from '../en/MyConfiguration'
import MyConfiguration_es from '../es/MyConfiguration'
import Contact_en from '../en/Contact';
import Contact_es from '../es/Contact';
import Services_en from '../en/Services';
import Services_es from '../es/Services';

/*i18n
  .use(initReactI18next)
  .init({
    resources: {
      // ...
    },
    lng: "ja",
    fallbackLng: "en",
  });
*/

i18next
  // .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "es",
    detection: {
      order: ["path", "localStorage", "htmlTag", "cookie"],
      caches: ["localStorage", "cookie"], // cache user language on
    },
    interpolation: { escapeValue: false },

     lng: 'es',

    resources: {
      es: {
        global: global_es,
        register_scream: registerTra_es,
        signin: signin_es,
        text: TestTras_es,
        FooterRoute: FooterRoutesTraslate_es,
        desk: DeskTraslate_es,
        configuration: MyConfiguration_es,
        Contact: Contact_es,
        Service: Services_es
      },
      en: {
        global: global_en,
        register_scream: registerTra_en,
        signin: signin_en,
        text: TestTras_en,
        FooterRoute: FooterRoutesTraslate_en,
        desk: DeskTraslate_en,
        configuration: MyConfiguration_en,
        Contact: Contact_en,
        Service: Services_en

      },
    }
  })